export const SAVE_TOKEN = 'SAVE_TOKEN'
export const SAVE_WALLET = 'SAVE_WALLET'
export const SAVE_BALANCE = 'SAVE_BALANCE'
export const SAVE_PRIVATE_KEY = 'SAVE_PRIVATE_KEY'
export const SAVE_ACTIVE_POOLS = 'SAVE_ACTIVE_POOLS'
export const SAVE_RPC_ERROR = 'SAVE_RPC_ERROR'
export const SAVE_PENDING_SWITCH = 'SAVE_PENDING_SWITCH'
export const CLEAR_ACTIVE_POOLS = 'CLEAR_ACTIVE_POOLS'
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO'
